import DashboardTemplate from '@/components/templates/DashboardTemplate';
import { Outlet } from 'react-router-dom';

const BankAccountOutlet = () => {
  return (
    <DashboardTemplate>
      <Outlet />
    </DashboardTemplate>
  );
};

export default BankAccountOutlet;
